<template>
	<div>
		<div :class="{'nav-open': $sidebar.showSidebar}">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>

	export default {
		data() {
			return {
				default: null
			}
		},
		created() {

			// if(String(this.$store.state.authentication.authToken).length < 64 || this.$store.state.authentication.authToken == null) {
			// 	this.$store.state.authentication.checked = true;
			
			// } else {
				
			// 	this.$http.get(this.config.api + "/user/authenticate").then(res => {

			// 		if (res.body.status == 'success') {
			// 			this.$store.state.authentication.loggedIn = true;
			// 			this.$store.state.authentication.user_hash = res.body.data.user_hash;
			// 			this.$store.state.authentication.user_name = res.body.data.user_name;
			// 			this.$store.state.authentication.user_role = res.body.data.user_role;
			// 			this.$store.state.authentication.checked = true;
			// 		}
			// 	})
			// }
		}
	}
</script>
<style>
	.text-primary {
        color: #112d9b;
    }
	.vs__dropdown-menu {
        margin-top: 3px;
        border: 2px solid #EEE;
        border-radius: 6px;
        padding: 0;
    }
    .vs__dropdown-option {
        padding: 8px 20px;
    }
	.vs__actions {
		display: none !important;
	}
    .vs--open {
        border: 2px solid #112d9b !important;
    }

    .vs__selected {
        font-family: "Open Sans", "Hanuman", sans-serif;
        color: #112d9b;
    }
	.vs__dropdown-option--highlight, .vs__dropdown-option--selected {
		color: #FFF;
		background-color: #112d9b;
	}

    .vs__dropdown-toggle {
        margin-top: 3px;
        margin-bottom: 24px;
		border: 0 !important;
    }

	.button-icon {
		margin-right: 3px;
	}
	@media (min-width: 992px) {
		.show-web {
			display: inline !important;
		}
		.show-mobile {
			display: none !important;
		}
	}
	@media (max-width: 991px) {
		.show-web {
			display: none !important;
		}
		.show-mobile {
			display: inline !important;
		}
	}
	.application-title {
		color: #112d9b;
	}
	.required {
		color: red;
	}
	
	.md-input::placeholder {
		font-size: 13px !important;
		color: #495057;
	}
	/* .md-card-header {
		display: none !important;
	} */
	.md-textarea {
		min-height: 80px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
		font-size: 14px;
	}

	.el-tabs__item.is-active {
		color: #2ec5b6 !important;
	}

	.el-tabs__item:hover {
		color: #2ec5b6 !important;
	}

	.el-tabs__active-bar {
		background-color: #2ec5b6 !important;
	}

	.md-progress-bar-fill {
		background-color: #2ec5b6 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.green {
		background-color: #2ec5b6;
		color: #FFF;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.neutral {
		background-color: #c189ee;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.late {
		background-color: #fab1a0;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.error {
		background-color: #f35734;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.gray {
		background-color: #bfbfbf;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.blue {
		background-color: #80e6ff;
		border-radius: 5px;
		margin-top: 5px;
		padding: 4px 8px;
	}

	.return {
		background-color: #fd79a8;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.md-list-item-text {
		font-family: "Open Sans", "Hanuman", sans-serif !important;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue